// Centralized theme-aware value selector
export function useSelectByTheme<T>(onDark: T, onLight: T, fallback?: T): T {
  if (typeof window !== 'undefined' && window.matchMedia) {
    // Try to get mode from document body/class if available (for SSR/CSR consistency)
    const html = document.documentElement;
    if (html.classList.contains('dark')) {
      return onDark;
    }
    if (html.classList.contains('light')) {
      return onLight;
    }
    // Fallback to matchMedia
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return onDark;
    }
    if (window.matchMedia('(prefers-color-scheme: light)').matches) {
      return onLight;
    }
  }
  // Default fallback
  const result = fallback !== undefined ? fallback : onLight;
  return result;
}

